export default __webpack_public_path__ + "static/media/grandson.a4847675.jpg";